import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { JackpotService } from 'src/app/services/lobby/jackpot.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { stringToNumber } from 'src/app/services/codeUtils';

@Component({
  selector: 'jackpot-counter',
  templateUrl: 'jackpot-counter.html',
  styleUrls: ['jackpot-counter.scss']
})

export class JackpotCounterComponent implements OnInit, OnDestroy {
  @Input() gameData: any;

  public jackpot: any[];

  constructor(
    private readonly config: ConfigService,
    private readonly jackpotService: JackpotService
  ) {
  }

  ngOnInit(): void {
    this.getJackpotData();
    this.updatePeriodically();
  }

  ngOnDestroy() {
  }

  async getJackpotData(): Promise<void> {
    if (this.gameData && this.gameData?.game_type_id) {
      const id: number = await this.getGameTypeIds();
      const preJackpot: any[] = await this.jackpotService.filteredJackpots(id);
      this.animateJackpot(preJackpot);
    } else {
      console.error("gameData or gameTypeId is missing or undefined");
    }
  }

  private updatePeriodically() {
    const intervalTimeSeconds = stringToNumber(this.config?.getConfig()?.FEATURE_JACKPOT_UPDATE_FREQUENCY) ?? 300;
    const intervalTimeMs = intervalTimeSeconds * 1000;
    setInterval(() => {
      this.getJackpotData();
    }, intervalTimeMs);
  }

  private async getGameTypeIds(): Promise<number> {
    return this.gameData?.game_type_id;
  }

  private animateJackpot(preJackpot: any[]): void {
    const jackpotCount: number = preJackpot.length;

    for (let i = 0; i < jackpotCount; i++) {
      const initialAmount: number = preJackpot[i]?.amt;
      const finalAmount: number = initialAmount;

      const animatedLevels: number = stringToNumber(this.config?.getConfig()?.FEATURE_JACKPOT_ANIMATED_LEVELS) ?? 2;

      if (i < animatedLevels) {
        const startingFactor: number = stringToNumber(this.config?.getConfig()?.FEATURE_JACKPOT_ANIMATION_FACTOR) ?? 0.9;
        let startingValue: number = Math.round(initialAmount * startingFactor);
        const animationDuration: number = stringToNumber(this.config?.getConfig()?.FEATURE_JACKPOT_ANIMATION_TIMING) ?? 60;
        const numberOfUpdatesPerSecond: number = stringToNumber(this.config?.getConfig()?.FEATURE_JACKPOT_ANIMATION_INTERVAL) ?? 15;
        const numberOfUpdates: number = animationDuration * numberOfUpdatesPerSecond;
        const updateAmount: number = (finalAmount - startingValue) / numberOfUpdates;

        let animationInterval: any;

        preJackpot[i].amt = startingValue;

        animationInterval = setInterval(() => {
          if (startingValue < finalAmount) {
            startingValue += updateAmount;
            preJackpot[i].amt = startingValue;
          } else {
            preJackpot[i].amt = finalAmount;
            clearInterval(animationInterval);
          }
        }, 1000 / numberOfUpdatesPerSecond);
      }
    }

    this.jackpot = preJackpot;
  }


}

